import { useEffect } from "react"

export default function useStoryViewportScroll({
  imgEl,
  endEl,
  windowEl,
  innerEl,
  boxHeightMobile = 340,
}) {
  useEffect(() => {
    if (typeof window === "undefined") return
    let lastProgress = -1
    const isMobile = () => window.matchMedia("(max-width: 767px)").matches
    const getHeader = () => {
      const v = getComputedStyle(document.documentElement).getPropertyValue(
        "--header-offset"
      )
      const n = parseInt(v, 10)
      if (Number.isFinite(n) && n > 0) return n
      const nav = document.querySelector(".navbar")
      return nav ? Math.round(nav.getBoundingClientRect().height) : 70
    }
    const onScroll = () => {
      if (
        !isMobile() ||
        !imgEl.current ||
        !endEl.current ||
        !windowEl.current ||
        !innerEl.current
      ) {
        return
      }
      const header = getHeader()
      const imgTop = imgEl.current.getBoundingClientRect().top
      const endTop = endEl.current.getBoundingClientRect().top
      const inner = innerEl.current
      const viewportH = boxHeightMobile
      const active = imgTop <= header + 0.5 && endTop > header + viewportH + 1
      const afterEnd = endTop <= header + viewportH + 1
      if (!active && !afterEnd) {
        if (lastProgress !== 0) {
          inner.style.transform = "translateY(0px)"
          lastProgress = 0
        }
        return
      }
      const totalScrollable = Math.max(0, inner.scrollHeight - viewportH)
      const startLine = header
      const distConsumed = Math.max(
        0,
        Math.min(totalScrollable, startLine - imgTop)
      )
      const done = afterEnd ? totalScrollable : distConsumed
      if (done !== lastProgress) {
        inner.style.transform = `translateY(-${done}px)`
        lastProgress = done
      }
    }
    const onResize = () => {
      if (innerEl.current) innerEl.current.style.transform = "translateY(0px)"
      lastProgress = -1
      onScroll()
    }
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    window.addEventListener("resize", onResize)
    return () => {
      window.removeEventListener("scroll", onScroll)
      window.removeEventListener("resize", onResize)
    }
  }, [imgEl, endEl, windowEl, innerEl, boxHeightMobile])
}
